import "./LeadListsTable.scss"

import { MenuItem, Pagination, PromptVariant, TableEmptyMessage } from "@skylead/component-library"
import React from "react"
import { useDispatch, useSelector } from "react-redux"

import { useLeadListsColumnsHook } from "../../../hooks/leadListsHooks"
import { showPrompt } from "../../../redux/actions"
import { deleteLists, exportList } from "../../../redux/list/listActions"
import { useCustomMenu, useGlobalTranslation } from "../../../utils/hook"
import { LeadListsHeader } from "../LeadListsHeader"
import BasicTable from "../NewTable"

const LeadListsTable = ({
  fetchLists,
  searchValue,
  setSearchValue,
  totalCount,
  currentPage,
  onPageChange,
  maxOnPage,
  handleChangeMaxOnPage,
  sortColumn,
  sortDirection,
  onSort,
}) => {
  const dispatch = useDispatch()
  const { tt } = useGlobalTranslation()

  const { language, lists } = useSelector(state => ({
    language: state.user.profile.language,
    lists: state.list.lists,
  }))

  const [customMenu, setCustomMenu] = useCustomMenu("custom-menu")

  const listsExist = lists.length > 0

  const handleDeleteList = listId => {
    dispatch(
      showPrompt(
        PromptVariant.WARNING,
        tt("list.table.delete-list.prompt.label"),
        tt("list.table.delete-list.prompt.msg"),
        async () => {
          const successfullyDeleted = await dispatch(deleteLists([listId]))

          if (successfullyDeleted) {
            await fetchLists()
          }
        },
        tt("delete"),
      ),
    )
  }

  const onExportList = list => {
    dispatch(exportList(tt, list))
  }

  const renderLeadListsMenu = (event, list = {}) => {
    setCustomMenu(
      event,
      <>
        <MenuItem
          icon="file-export-20"
          label={tt("list.export")}
          onClickContainer={() => onExportList(list)}
        />
        <MenuItem
          icon="trash-20"
          label={tt("list.delete-list")}
          danger
          onClickContainer={() => handleDeleteList(list.id)}
        />
      </>,
    )
  }

  const leadListsColumns = useLeadListsColumnsHook(renderLeadListsMenu, language)

  const renderBasicTableWithPagination = () => {
    return (
      <>
        <BasicTable
          columns={leadListsColumns}
          data={lists}
          showCheckbox={false}
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        <Pagination
          count={totalCount}
          tt={tt}
          page={currentPage}
          changePage={onPageChange}
          maxOnPage={maxOnPage}
          handleChangeMaxOnPage={handleChangeMaxOnPage}
        />
      </>
    )
  }

  return (
    <div className="lead-lists-table">
      {customMenu}
      <LeadListsHeader searchValue={searchValue} onSearchValueChange={setSearchValue} />
      {listsExist ? (
        renderBasicTableWithPagination()
      ) : (
        <TableEmptyMessage
          lastQueriedSearch={searchValue}
          icon="illustration-style-06"
          svgClassName="illustration-svg-empty-table"
          illustrationMessage={tt("no-lists.table-data.msg")}
          tt={tt}
        />
      )}
    </div>
  )
}

export default LeadListsTable
